import { Root, rootLoader as loader, useLoaderData, useLocation } from '@ubo/losse-sjedel';
import type { LinksFunction, RootProps } from '@ubo/losse-sjedel';
import PageNotFound from '~/components/layout/PageNotFound';
import styles from '~/global.css';
import FlexContent from './graphql/FlexContent';
import Queries from './graphql/Queries';
import PostTypes from './graphql/PostTypes';

export const flexData = {
  flexContent: FlexContent,
  queries: Queries,
  postTypes: PostTypes
};

export const links: LinksFunction = () => {
  return [
  {
    href: 'https://use.typekit.net/bsl3iqc.css',
    rel: 'preload',
    as: 'style'
  },
  {
    href: 'https://use.typekit.net/bsl3iqc.css',
    rel: 'stylesheet'
  },
  {
    rel: 'preload',
    as: 'style',
    href: styles
  },
  {
    href: '/static/nprogress.min.css',
    rel: 'stylesheet',
    async: true
  },
  {
    rel: 'preload',
    as: 'style',
    href: styles
  },
  {
    href: styles,
    rel: 'stylesheet'
  },
  {
    href: '/manifest.json',
    rel: 'manifest'
  },
  {
    rel: 'icon',
    href: '/favicon.png',
    type: 'image/png'
  }];

};

export { loader };

export function CatchBoundary() {
  return <PageNotFound />;
}

export default function App() {
  const data = useLoaderData<RootProps>();
  const location = useLocation();

  let headChildren;

  //   if (location.pathname.includes('/migratie')) {
  //     headChildren = (
  //       <>
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "FAQPage",
  //   "mainEntity": [
  //     {
  //       "@type": "Question",
  //       "name": "Hoe verloopt een Microsoft 365 migratie bij ALTA‑ICT?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Wij verzorgen de volledige migratie: inventarisatie, veilige datamigratie, training en 24/7 support. Alles volgens ISO 27001 en NEN 7510 richtlijnen."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Hoelang duurt een gemiddelde migratie?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "De meeste migraties duren enkele dagen tot weken, afhankelijk van de omvang en complexiteit van de omgeving."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Is de migratie veilig voor mijn data?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, wij werken met gecertificeerde processen en zorgen dat er geen dataverlies optreedt tijdens de migratie."
  //       }
  //     }
  //   ]
  // }`
  //           }}
  //         />
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "Service",
  //   "serviceType": "Microsoft 365 Migratie",
  //   "provider": {
  //     "@type": "Organization",
  //     "name": "ALTA‑ICT B.V.",
  //     "url": "https://alta-ict.nl/diensten/migratie"
  //   },
  //   "description": "ALTA‑ICT regelt een veilige en zorgeloze Microsoft 365 migratie voor het MKB. Wij zorgen voor probleemloze datamigratie, training van medewerkers en volledige ondersteuning met ISO 27001 en NEN 7510‑gecertificeerde processen."
  // }`
  //           }}
  //         />
  //       </>
  //     )
  //   } else if (location.pathname.includes('/moderne-werkplek')) {
  //     headChildren = (
  //       <>
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "FAQPage",
  //   "mainEntity": [
  //     {
  //       "@type": "Question",
  //       "name": "Wat is een moderne werkplek?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Een moderne werkplek maakt gebruik van Microsoft 365, Teams, SharePoint en cloudoplossingen zodat medewerkers overal veilig kunnen werken."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Waarom zou ik overstappen naar een moderne werkplek?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Het verhoogt productiviteit, flexibiliteit en beveiliging, met centrale toegang tot bestanden en applicaties."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Bieden jullie ondersteuning na de inrichting?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, wij bieden volledige training en 24/7 support zodat jouw team optimaal gebruik kan maken van de nieuwe omgeving."
  //       }
  //     }
  //   ]
  // }`
  //           }}
  //         />
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "Service",
  //   "serviceType": "Moderne Werkplek",
  //   "provider": {
  //     "@type": "Organization",
  //     "name": "ALTA‑ICT B.V.",
  //     "url": "https://alta-ict.nl/diensten/moderne-werkplek"
  //   },
  //   "description": "ALTA‑ICT helpt bedrijven met het inrichten van de moderne werkplek. Altijd en overal veilig werken met Microsoft 365, Teams, SharePoint en cloudoplossingen, ondersteund door 24/7 support en deskundige begeleiding."
  // }`
  //           }}
  //         />
  //       </>
  //     )
  //   } else if (location.pathname.includes('/beheer')) {
  //     headChildren = (
  //       <>
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "FAQPage",
  //   "mainEntity": [
  //     {
  //       "@type": "Question",
  //       "name": "Wat valt er onder IT‑beheer bij ALTA‑ICT?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Wij zorgen voor proactieve monitoring, updates, back‑ups, beveiligingsbeheer en directe ondersteuning bij problemen."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Is IT‑beheer geschikt voor kleine bedrijven?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, wij zijn gespecialiseerd in MKB‑oplossingen en stemmen IT‑beheer volledig af op jouw bedrijfsgrootte."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Bieden jullie 24/7 ondersteuning?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, onze supportdesk is 24/7 bereikbaar voor kritieke problemen en proactieve monitoring voorkomt veel issues."
  //       }
  //     }
  //   ]
  // }`
  //           }}
  //         />
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "Service",
  //   "serviceType": "IT‑Beheer",
  //   "provider": {
  //     "@type": "Organization",
  //     "name": "ALTA‑ICT B.V.",
  //     "url": "https://alta-ict.nl/diensten/beheer"
  //   },
  //   "description": "ALTA‑ICT verzorgt proactief IT‑beheer en 24/7 monitoring voor MKB‑bedrijven. Wij zorgen voor betrouwbare systemen, back‑ups, beveiligingsupdates en deskundige support."
  // }`
  //           }}
  //         />
  //       </>
  //     )
  //   } else if (location.pathname.includes('/beveiliging')) {
  //     headChildren = (
  //       <>
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "FAQPage",
  //   "mainEntity": [
  //     {
  //       "@type": "Question",
  //       "name": "Hoe beschermt ALTA‑ICT mijn bedrijf tegen cyberaanvallen?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Wij implementeren geavanceerde beveiligingsoplossingen, inclusief monitoring, back‑ups, multi‑factor authenticatie en patchmanagement."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Zijn jullie processen gecertificeerd?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, wij werken volgens ISO 27001 en NEN 7510 richtlijnen voor maximale veiligheid en compliance."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Bieden jullie beveiligingstrainingen voor medewerkers?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, wij bieden security awareness‑trainingen zodat medewerkers phishing en andere dreigingen herkennen en voorkomen."
  //       }
  //     }
  //   ]
  // }`
  //           }}
  //         />
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "Service",
  //   "serviceType": "IT‑Beveiliging",
  //   "provider": {
  //     "@type": "Organization",
  //     "name": "ALTA‑ICT B.V.",
  //     "url": "https://alta-ict.nl/diensten/beveiliging"
  //   },
  //   "description": "ALTA‑ICT beschermt organisaties tegen cyberdreigingen met geavanceerde IT‑beveiligingsoplossingen. Met ISO 27001- en NEN 7510‑gecertificeerde processen zorgen we voor maximale dataveiligheid en compliance."
  // }`
  //           }}
  //         />
  //       </>
  //     )
  //   } else if (location.pathname.includes('/diensten')) {
  //     headChildren = (
  //       <>
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "FAQPage",
  //   "mainEntity": [
  //     {
  //       "@type": "Question",
  //       "name": "Welke diensten biedt ALTA‑ICT aan?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Wij zijn gespecialiseerd in Microsoft 365 migratie, moderne werkplek inrichting, IT‑beheer en IT‑beveiliging voor MKB‑bedrijven."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Zijn jullie processen gecertificeerd?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, wij werken volgens ISO 27001 en NEN 7510 gecertificeerde processen en hebben een positief auditadvies ontvangen."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Bieden jullie ondersteuning na oplevering?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, wij bieden volledige training, 24/7 support en proactief beheer om jouw IT‑omgeving optimaal draaiende te houden."
  //       }
  //     },
  //     {
  //       "@type": "Question",
  //       "name": "Kan ik een gratis IT‑scan aanvragen?",
  //       "acceptedAnswer": {
  //         "@type": "Answer",
  //         "text": "Ja, wij bieden een gratis IT‑scan aan waarmee we je huidige IT‑omgeving analyseren en verbeterpunten in kaart brengen."
  //       }
  //     }
  //   ]
  // }`
  //           }}
  //         />
  //         <script
  //           type="application/ld+json"
  //           dangerouslySetInnerHTML={{
  //             __html: `{
  //   "@context": "https://schema.org",
  //   "@type": "Service",
  //   "serviceType": "Microsoft 365 Migratie, Moderne Werkplek, IT‑Beheer & IT‑Beveiliging",
  //   "provider": {
  //     "@type": "Organization",
  //     "name": "ALTA‑ICT B.V.",
  //     "url": "https://alta-ict.nl/diensten"
  //   },
  //   "description": "ALTA‑ICT is dé specialist voor het MKB in Microsoft 365 migratie, moderne werkplek, IT‑beheer en IT‑beveiliging. Wij zorgen voor een veilige, efficiënte en toekomstbestendige werkomgeving met ISO 27001- en NEN 7510‑gecertificeerde processen en 24/7 support."
  // }`
  //           }}
  //         />
  // </>
  //   )
  // }

  // @ts-ignore
  return <Root {...data} lang={location.pathname.includes('/en/') ? 'en' : 'nl'} headChildren={headChildren} />;
}